import * as React from "react";
import { ClipboardCheck, FileText, PenTool, PhoneCall, ThumbsUp } from "lucide-react";
import { Badge } from "@/components/ui/badge";
const steps = [{
  title: "提出申請",
  description: "填寫線上表單或直接來電洽詢，簡述您的基本需求。",
  icon: FileText
}, {
  title: "專人聯繫",
  description: "我們的專業顧問將於 24 小時內與您聯繫，深入了解細節。",
  icon: PhoneCall
}, {
  title: "方案評估",
  description: "針對您的條件與需求，量身打造並評估最適合的解決方案。",
  icon: ClipboardCheck
}, {
  title: "簽約撥款",
  description: "確認方案內容無誤後進行簽約，並以最快速度完成撥款作業。",
  icon: PenTool
}, {
  title: "結案售後",
  description: "提供完善的後續諮詢服務，確保您的權益與長期滿意度。",
  icon: ThumbsUp
}];
export default function ApplicationProcessBrief() {
  return <section id="申請流程簡述" className="bg-background py-16 md:py-24 font-sans">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center md:mb-16">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-4">
            申請流程簡述
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            只需簡單五個步驟，我們將為您提供最專業、迅速的服務體驗。
          </p>
        </div>

        <div className="relative mx-auto max-w-5xl">
          {}
          <div className="absolute top-8 left-[10%] hidden w-[80%] border-t-2 border-dotted border-muted-foreground/30 md:block z-0" />
          
          {}
          <div className="absolute top-8 bottom-8 left-8 hidden border-l-2 border-dotted border-muted-foreground/30 max-md:block z-0" />

          <div className="grid grid-cols-1 gap-8 md:grid-cols-5 md:gap-4">
            {steps.map((step, i) => <div key={i} data-index={i} className="relative flex flex-row items-start gap-4 md:flex-col md:items-center rounded-lg">
                {}
                <div className="relative flex size-16 shrink-0 items-center justify-center rounded-full border-2 border-chart-2 bg-background z-10 shadow-sm">
                  <step.icon className="size-6 text-foreground" strokeWidth={1.5} />
                  
                  {}
                  <Badge variant="secondary" className="absolute -right-2 -top-2 flex size-6 items-center justify-center rounded-full p-0 text-xs font-bold shadow-sm border-2 border-background">
                    {i + 1}
                  </Badge>
                </div>

                {}
                <div className="flex flex-col gap-2 pt-2 md:items-center md:text-center">
                  <h3 className="text-lg font-semibold leading-none tracking-tight">
                    {step.title}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}